<template>
  <input
    v-if="!showDatePicker"
    ref="input"
    autocomplete="off"
    class="filter-text-input"
    :name="placeholder"
    :placeholder="placeholder"
    :style="icon ? `background-image: url(${icon})` : undefined"
    :type="type"
    :value="value"
    @input="$emit('change', $event.target.value)"
    @keypress.enter="$emit(`enter`)" />

  <Datepicker
    v-else-if="showDatePicker"
    :date-format="`dd.MM.yyyy`"
    day-wrapper-class="datepicker-selection-day"
    :enable-empty-selection="enableEmptyDatepickerSelection"
    :init-value="value"
    :label="placeholder"
    :mode="DatepickerMode.FILTER"
    month-wrapper-class="datepicker-selection-month"
    :months="months"
    selection-class="datepicker-selection"
    :validation-mode="DatepickerValidationMode.VISUAL"
    year-wrapper-class="datepicker-selection-year"
    @error="handleDatepickerError"
    @update="$emit('change', $event)" />
</template>

<script>
  import { Datepicker, DatepickerMode, DatepickerValidationMode } from '@ringana/datepicker';
  import ErrorHandlerHelper from '@/helpers/ErrorHandlerHelper';

  export default {
    name: `FilterTextInput`,
    components: { Datepicker },
    model: {
      event: `change`,
      prop: `value`,
    },
    data() {
      return {
        DatepickerMode,
        DatepickerValidationMode,
        months: [`1`, `2`, `3`, `4`, `5`, `6`, `7`, `8`, `9`, `10`, `11`, `12`],
      };
    },
    props: {
      enableEmptyDatepickerSelection: {
        default: false,
        type: Boolean,
      },
      icon: {
        default: ``,
        type: String,
      },
      placeholder: {
        default: ``,
        type: String,
      },
      showDatePicker: {
        default: false,
        type: Boolean,
      },
      type: {
        default: ``,
        type: String,
      },
      value: {
        default: null,
        type: [Date, String],
      },
    },
    mounted() {
      this.initMonthStrings();
    },
    methods: {
      handleDatepickerError($event) {
        ErrorHandlerHelper.handleError($event.errorText, {
          logToConsole: true,
        });
      },
      initMonthStrings() {
        if(!this.showDatePicker) {
          return;
        }

        // This currently checks if Locize is initialized.
        // If Locize is not initialized the default values defined in 'data' are used.
        try {
          this.$t(`datepicker:months.january`);
        } catch (err) {
          return;
        }

        this.months = [
          this.$t(`datepicker:months.january`),
          this.$t(`datepicker:months.february`),
          this.$t(`datepicker:months.march`),
          this.$t(`datepicker:months.april`),
          this.$t(`datepicker:months.may`),
          this.$t(`datepicker:months.june`),
          this.$t(`datepicker:months.july`),
          this.$t(`datepicker:months.august`),
          this.$t(`datepicker:months.september`),
          this.$t(`datepicker:months.october`),
          this.$t(`datepicker:months.november`),
          this.$t(`datepicker:months.december`),
        ].map(month => month.toUpperCase());
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/styles/rin-variables.less';

  ::v-deep {
    .datepicker-selection {
      background: transparent !important;
      border: 1px solid @colorBlack !important;
    }
  }

  .filter-text-input {
    background-color: transparent;
    background-position: calc(100% - 15px);
    background-repeat: no-repeat;
    border: 1px solid @colorBlack;
    font-size: @fontSizeS;
    letter-spacing: 1.5px;
    padding: 10px;

    @media @mobile {
      margin: 25px 0 0 0;
      width: 100%;
    }
  }

  ::placeholder {
    color: @colorBlack;
    text-transform: uppercase;
  }
</style>
